import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService as AS } from '@data/admin/admin.service';
import {
  ConfirmationPopupOption,
  ConfirmationResponse,
} from '@shared/common-components/confirmation-popup/confirmation-popup.component';
import { changeDateFormatJavaToUi } from '@shared/common-functions/utility';
import { AdminService, PublishData, PublishDataConversion } from '../services/admin.service';
import { custom } from "devextreme/ui/dialog"
import { DxTextBoxComponent } from 'devextreme-angular';
import { ProjectService } from '@data/project/project.service';
import { CommonDataService } from '@shared/services/common-data.service';
import { takeWhile } from 'rxjs/operators';
import { NotificationService } from '@shared/services/notification.service';

interface projectSearch{
  projectId:number|null;
  title:string;
}


@Component({
    selector: 'app-system-admin',
    templateUrl: './system-admin.component.html',
    styleUrls: ['./system-admin.component.less'],
    standalone: false
})
export class SystemAdminComponent implements OnInit {
  titleList: any;
  showPopup: boolean = false;
  showPublishPopup: boolean = false;
  showRevokePopup: boolean = false;
  popupId: string = '';
  popupType: string = '';
  publishListData: PublishData[]=[];
  allPSRGroupsLists: any;
  revokePSRGroupsLists: any;
  selectedPublishGroups: any[]=[];
  selectedRevokeGroups: any[]=[];
  allowedRevokeGroups: any[]=[];
  selectedGroupItems: any;
  disAdmin: boolean = false;
  displayColumns = [
    { caption: 'Weekending Date', dataField: 'weekendingDt', dataType: 'date', format: "MM/dd/yy"},
    { caption: 'Report Name', dataField: 'reportName', dataType: 'string', format: ""},
    { caption: 'Recipient Name', dataField: 'recipientName', dataType: 'string', format: ""},
    { caption: 'Recipient Email', dataField: 'recipientEmail', dataType: 'string', format: ""},
    { caption: 'Published By', dataField: 'publishedBy', dataType: 'string', format: ""},
    { caption: 'Published On', dataField: 'publishedOn', dataType: 'datetime', format: "MM/dd/yy, HH:mm"},
    { caption: 'Last Accessed Date', dataField: 'lastAccessedDate', dataType: 'datetime', format: "MM/dd/yy, HH:mm"},
    { caption: 'Access Revoked', dataField: 'accessRevokedFlag', dataType: 'string', format: ""},
  ];
  title: string = '';
  copyTitle: any;
  currentWeekendDate: Date = new Date(
    new Date().setDate(new Date().getDate() - new Date().getDay() + 6)
  );

  isLoading = true;
  loadingWeekendingRollback = true;
  loadingPSRGroupsList = true;

  currentWeekendingDt: string | Date;
  rollbackStatus: boolean;
  openConfirmationPopup: boolean = false;
  confirmationPopupOption: ConfirmationPopupOption;
  isNotifyVisible: boolean = false;
  notifyMessage: any;
  notifyType: string = 'success';
  isPublishDisabled: boolean = true;
  PSRGroupsDataSource: any;

  creatingProject=false;
  showPublish: boolean = true;
  disPublish: boolean = false;

  constructor(private _notify: NotificationService){}
    

  ngOnInit(): void {}

  ngOnDestroy(){
    this._notify.removeErrorOnTabChange('system-admin');
  }


}
